import { useTranslation } from 'react-i18next';
import './LangSwitcher.css';

const lngs = {
    ru: { nativeName: 'RU' },
    en: { nativeName: 'EN' },
};

function LangSwitcher() {
    const { i18n } = useTranslation();
  
    return (
        <div className='LangSwitcher'>
        {Object.keys(lngs).map((lng) => (
            <span
                key={lng}
                style={{ fontWeight: i18n.resolvedLanguage === lng ? '600' : '300' }}
                onClick={() => i18n.changeLanguage(lng)}
            >
                {lngs[lng].nativeName}
            </span>
        ))}
        </div>
    );
}
  
export default LangSwitcher;
